import React, { useState } from 'react';
import classNames from 'classnames';
import css from './EditListingLayoutSideNav.module.css';
import { ExternalLink, Icons, NamedLink } from '../../../../components';
import { isArrayLength } from '../../../../util/genericHelpers';

const RenderAccordions = ({ accordions, toggleDrawer }) => {
  const [openAccordion, setOpenAccordion] = useState(null);
  const [openSubAccordion, setOpenSubAccordion] = useState(null);

  const toggleAccordion = id => setOpenAccordion(openAccordion === id ? null : id);
  const toggleSubAccordion = id => setOpenSubAccordion(openSubAccordion === id ? null : id);

  return (
    <div className={css.sideNavContent}>
      {accordions.map(accordion => (
        <div key={accordion.id} className={css.accordion}>
          {/* If hideIcon is true, render as a link instead of an accordion */}
          {accordion.hideIcon ? (
            accordion.isExternal ? (
              <ExternalLink
                href={accordion.pageName}
                className={css.accordionHeader}
                target={accordion?.openInSameTab ? '_self' : '_blank'}
              >
                {accordion.title}
              </ExternalLink>
            ) : (
              <NamedLink
                name={accordion.pageName}
                className={css.accordionHeader}
                params={accordion.params}
              >
                {accordion.title}
              </NamedLink>
            )
          ) : (
            <div
              className={classNames(
                css.accordionHeader,
                openAccordion === accordion.id && css.active
              )}
              onClick={() => toggleAccordion(accordion.id)}
            >
              {accordion.title}
              <Icons name={openAccordion === accordion.id ? 'upAngle' : 'downAngle'} />
            </div>
          )}

          {openAccordion === accordion.id && !accordion.hideIcon && (
            <div className={css.accordionContent}>
              {accordion.items ? (
                <ul className={css.accordionList}>
                  {accordion.items.map((item, index) => (
                    <li key={`${item.key}-${index}`} className={css.accordionItem}>
                      {item.isExternal ? (
                        <ExternalLink
                          href={item.pageName}
                          className={css.link}
                          target={item?.openInSameTab ? '_self' : '_blank'}
                        >
                          {item.label}
                        </ExternalLink>
                      ) : (
                        <div onClick={toggleDrawer}>
                          <NamedLink name={item.pageName} className={css.link} params={item.params}>
                            {item.label}
                          </NamedLink>
                        </div>
                      )}
                    </li>
                  ))}
                </ul>
              ) : accordion.sections ? (
                accordion.sections.map(section => (
                  <div key={section.id} className={css.subAccordion}>
                    {/* If hideIcon is true for section, render as a link instead of a sub-accordion */}
                    {section.hideIcon ? (
                      section.isExternal ? (
                        <ExternalLink
                          href={section.pageName}
                          className={css.subAccordionHeader}
                          target={section?.openInSameTab ? '_self' : '_blank'}
                        >
                          {section.title}
                        </ExternalLink>
                      ) : (
                        <NamedLink
                          name={section.pageName}
                          className={css.subAccordionHeader}
                          params={section.params}
                        >
                          {section.title}
                        </NamedLink>
                      )
                    ) : (
                      <div
                        className={classNames(
                          css.subAccordionHeader,
                          openSubAccordion === section.id && css.active
                        )}
                        onClick={() => toggleSubAccordion(section.id)}
                      >
                        {section.title}
                        <Icons name={openSubAccordion === section.id ? 'upAngle' : 'downAngle'} />
                      </div>
                    )}

                    {openSubAccordion === section.id && !section.hideIcon && (
                      <ul className={css.accordionList}>
                        {isArrayLength(section.items) &&
                          section.items.map(item => (
                            <li key={item.key} className={css.accordionItem}>
                              {item.isExternal ? (
                                <ExternalLink
                                  href={item.pageName}
                                  className={css.link}
                                  target={item?.openInSameTab ? '_self' : '_blank'}
                                >
                                  {item.label}
                                </ExternalLink>
                              ) : (
                                <NamedLink
                                  name={item.pageName}
                                  className={css.link}
                                  params={item.params}
                                >
                                  {item.label}
                                </NamedLink>
                              )}
                            </li>
                          ))}
                      </ul>
                    )}
                  </div>
                ))
              ) : null}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default RenderAccordions;
